/* 8TH SIN — NAV DRAWER v6 */
(function () {
  'use strict';

  if (document.getElementById('navDrawer')) return;

  var drawer = document.createElement('div');
  drawer.id = 'navDrawer';
  drawer.className = 'nav-drawer';
  drawer.setAttribute('aria-hidden', 'true');
  drawer.innerHTML =
    '<button class="nav-drawer-close" id="navDrawerClose" aria-label="Close">&#x2715;</button>' +
    '<nav class="nav-drawer-links">' +
      '<a class="nav-drawer-link" href="/">Home</a>' +
      '<a class="nav-drawer-link" href="/collections/all">Shop All</a>' +
      '<a class="nav-drawer-link" href="/pages/contact">Contact Us</a>' +
    '</nav>' +
    '<div class="nav-drawer-footer">8TH SIN &middot; Delhi &middot; ' + new Date().getFullYear() + '</div>';
  document.body.appendChild(drawer);

  function open() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.getElementById('navDrawerClose').addEventListener('click', close);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.pm-nav-menu, .cg-nav-menu, .pg-nav-menu, .cv-nav-menu');
    if (btn) { e.preventDefault(); open(); }
  });
})();
